import { z } from 'zod'

export const reportFormat = z.enum(['csv', 'json'])
export type ReportFormat = z.infer<typeof reportFormat>
